(function (root, factory) {
	'use strict';

	if (typeof define === 'function' && define.amd) {
		// AMD
		define(['components/utilities/utilities'], factory);
	} else if (typeof exports === 'object') {
		// Node, CommonJS-like
		module.exports = factory(require('components/utilities/utilities'));
	} else {
		// Browser globals (root is window)
		root.s5SToggleLink = factory(root.s5Utils);
	}
}(this, function (utils) {
	'use strict';

	/**
	 * Toggle link
	 * A plugin for making links toggle other content (with accessibility features).
	 * @version 2.0.7
	 * @exports toggleLink
	 */
	var toggleLink = {

		openDropdown: null,

		/**
		 * The initialization function for this module.
		 * @public
		 */
		init: function () {
			this._initToggleLink();
			this._initToggleSelect();
			this._initAnchorSupport();

			if (document.querySelector('.toggle-dropdown') !== null) {
				this._attachOutsideClickEvent();
			}
		},


		/**
		 * Add toggle feature to the links.
		 * @private
		 */
		_initToggleLink: function () {
			var that = this;

			utils.forEachElement('[data-type="toggle"]', function (el) {
				var target = document.getElementById(el.getAttribute('aria-controls'));

				if (el.tagName.toLowerCase() === 'a' && el.getAttribute('role') === null) {
					el.setAttribute('role', 'button');
				}

				utils.addEventListener(el, 'click', function (event) {
					var evt = event || window.event,
						link = this;

					if (evt.preventDefault !== undefined) { evt.preventDefault(); } else { evt.returnValue = false; }
					if (evt.stopPropagation !== undefined) { evt.stopPropagation(); }

					var currentState = target.getAttribute('aria-hidden') === 'true',
						group = target.getAttribute('data-togglegroup'),
						groupNoClose = target.getAttribute('data-togglegoup-noclose') && target.getAttribute('data-togglegoup-noclose') === 'true' || false;

					// Close other toggles that are opened in this group.
					if (group !== undefined) {
						utils.forEachElement('[data-togglegroup="' + group + '"][aria-hidden="false"]', function (groupEl) {
							var groupElId = groupEl.getAttribute('id');
							if (document.querySelector('[href="#' + groupElId + '"]') !== link) {
								that._closeContent(document.querySelector('[href="#' + groupElId + '"]'));
							}
						});

						// If this is the only open content in the group and we don't allow all contents to be closed, stop here.
						if (groupNoClose && !currentState) {
							return false;
						}
					}

					if (currentState === true) {
						that._openContent(link);
					} else {
						that._closeContent(link);
					}
				});
			});
		},


		/**
		 * Add toggle feature to the selects.
		 * @private
		 */
		_initToggleSelect: function () {
			utils.forEachElement('[data-type="toggle-select"]', function (el) {
				utils.addEventListener(el, 'change', function () {
					var targetLink = document.querySelector('[aria-controls="' + el.value + '"]');
					if (targetLink !== null) {
						targetLink.click();
					}
				});
			});
		},


		/**
		 * Opens the content.
		 * @param {Object} link - The link to be opened as a DOM Node.
		 * @private
		 */
		_openContent: function (link) {
			var target = document.getElementById(link.getAttribute('aria-controls')),
				currentText = link.innerHTML,
				nextText = link.getAttribute('data-toggletext') || currentText,
				dropdown = utils.hasClass(link.parentNode, 'toggle-dropdown') ? link.parentNode : null,
				activeClass = link.getAttribute('data-active-class') || 'is-active',
				inactiveClass = link.getAttribute('data-inactive-class') || false;

			target.setAttribute('aria-hidden', false);
			link.setAttribute('aria-expanded', true);
			link.setAttribute('data-toggletext', currentText);
			link.innerHTML = nextText;
			utils.rerenderElement('lt-ie9');

			utils.addClass(link, activeClass);
			if (inactiveClass) {
				utils.removeClass(link, inactiveClass);
			}

			if (dropdown) {
				this.openDropdown = link;
			}

			if (target.querySelector('input[type="text"]') !== null) {
				target.querySelector('input[type="text"]').focus();
			}
			else if (target.querySelector('input[type="search"]') !== null) {
				target.querySelector('input[type="search"]').focus();
			} else {
				if (target.getAttribute('tabindex') === null) {
					target.setAttribute('tabindex', '-1');
				}
			}
		},


		/**
		 * Close the content.
		 * @param {Object} link - The link to be closed as a DOM Node.
		 * @private
		 */
		_closeContent: function (link) {
			var target = document.getElementById(link.getAttribute('aria-controls')),
				currentText = link.innerHTML,
				nextText = link.getAttribute('data-toggletext') || currentText,
				activeClass = link.getAttribute('data-active-class') || 'is-active',
				inactiveClass = link.getAttribute('data-inactive-class') || false;

			target.setAttribute('aria-hidden', true);
			link.setAttribute('aria-expanded', false);
			link.setAttribute('data-toggletext', currentText);
			link.innerHTML = nextText;
			utils.rerenderElement('lt-ie9');

			utils.removeClass(link, activeClass);
			if (inactiveClass) {
				utils.addClass(link, inactiveClass);
			}

			this.openDropdown = null;
		},


		/**
		 * If we got an anchor in the url, open the matching togglelink (and it's parents if they are nested).
		 * @private
		 */
		_initAnchorSupport: function () {
			var hash = window.location.hash,
				link = null,
				target = null,
				linkParent = null,
				linkParents = [];

			if (hash === '') {
				return false;
			}

			hash = hash.replace('#', '');
			// error when id don't exists
			target = document.getElementById(hash);
			link = document.querySelector('[aria-controls="' + hash + '"]');
			linkParent = target.parentNode;

			if (target === null || link === null) {
				return false;
			}

			while (linkParent !== null) {
				if (utils.hasClass(linkParent, 'expandable') !== false) {
					linkParents.push(linkParent);
				}
				linkParent = linkParent.parentNode;
			}

			for (var i = 0; i < linkParents.length; i++) {
				var l = document.querySelector('[aria-controls="' + linkParents[i].getAttribute('id') + '"]');

				this._openContent(l);
			}

			this._openContent(link);
		},


		/**
		 * Attach an click-event to the window object that hides open dropdown on click outside them.
		 * @private
		 */
		_attachOutsideClickEvent: function () {
			var that = this;

			utils.addEventListener(window, 'click', function (event) {
				if (that.openDropdown !== null) {
					var currentTag = event.target;

					while (currentTag !== null && utils.hasClass(currentTag, 'toggle-dropdown') === false) {
						currentTag = currentTag.parentNode;
					}

					if (currentTag === null) {
						that.openDropdown.click();
					}
				}
			});
		}
	};


	return toggleLink;
}));